// extracted by mini-css-extract-plugin
module.exports = {"text":"footer_text__464ds"};